import { useState } from "react";
import { summaryGroups } from "@/mocks/home";

export default function Summary() {
  const [openId, setOpenId] = useState<string | null>(summaryGroups[0]?.id ?? null);

  return (
    <section id="summary" className="border-t border-background-200 bg-background-100 py-10 md:py-14">
      <div className="mx-auto flex w-full max-w-6xl flex-col gap-7 px-4 md:px-6">
        {/* 分区头 */}
        <div className="flex items-center justify-between">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-secondary-200 text-secondary-900">
                <i className="ri-list-check-3 text-lg" />
              </span>
              <h3 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">汇总帖 · 整理清单</h3>
            </div>
            <p className="mt-2 text-sm text-foreground-500">
              把散落内容收拾成一张张可查的清单：哪桩已核实、哪个还待补充，一眼看清。
            </p>
          </div>
          <span className="hidden items-center gap-1.5 whitespace-nowrap rounded-full bg-accent-100 px-3 py-1.5 text-sm text-accent-900 md:flex">
            <i className="ri-file-list-3-line" />
            长期维护 · 随新瓜更新
          </span>
        </div>

        {/* 清单折叠列表 */}
        <div className="flex flex-col gap-4">
          {summaryGroups.map((g) => {
            const isOpen = openId === g.id;
            return (
              <article key={g.id} className="overflow-hidden rounded-lg bg-background-50">
                <button
                  type="button"
                  onClick={() => setOpenId(isOpen ? null : g.id)}
                  className="flex w-full items-center gap-4 p-3 text-left transition-colors hover:bg-background-50/80 sm:gap-5 sm:p-4"
                >
                  <img
                    src={g.cover}
                    alt={`98黑料 整理清单：${g.title}`}
                    title={`98黑料 ${g.type} ${g.title}`}
                    className="hidden aspect-square w-20 shrink-0 rounded-md object-cover object-top sm:block md:w-24"
                  />
                  <div className="flex flex-1 items-start gap-3 sm:items-center">
                    <span className="hidden shrink-0 rounded-full bg-primary-100 px-3 py-1 font-heading text-xs font-bold text-primary-700 sm:inline-block">
                      {g.no}
                    </span>
                    <div className="min-w-0 flex-1">
                      <div className="flex flex-wrap items-center gap-2">
                        <span className="whitespace-nowrap rounded-full bg-secondary-100 px-2 py-0.5 text-xs text-secondary-900">
                          {g.type}
                        </span>
                        <h4 className="text-base font-semibold text-foreground-950 md:text-lg">{g.title}</h4>
                      </div>
                      <p className="mt-1 text-sm text-foreground-500">{g.meta}</p>
                      {!isOpen && (
                        <p className="mt-1 line-clamp-1 text-sm text-foreground-600 sm:hidden">{g.excerpt}</p>
                      )}
                    </div>
                  </div>
                  <span
                    className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full transition-colors ${
                      isOpen ? "bg-primary-500 text-background-50" : "bg-secondary-100 text-secondary-900"
                    }`}
                  >
                    {isOpen ? <i className="ri-arrow-up-s-line text-lg" /> : <i className="ri-arrow-down-s-line text-lg" />}
                  </span>
                </button>

                {/* 展开内容 */}
                {isOpen && (
                  <div className="border-t border-background-200 px-4 pb-5 pt-4 sm:px-5">
                    <div className="flex flex-col gap-5 md:flex-row">
                      <p className="flex-1 text-sm leading-relaxed text-foreground-600">{g.excerpt}</p>
                      <div className="flex shrink-0 flex-col gap-2 sm:w-56">
                        {g.points.map((p) => (
                          <div key={p} className="flex items-center gap-2 text-sm text-foreground-700">
                            <i className="ri-checkbox-circle-line text-accent-600" />
                            {p}
                          </div>
                        ))}
                      </div>
                      <div className="flex shrink-0 items-start gap-3 md:flex-col md:items-stretch">
                        <a
                          href="#collection"
                          className="whitespace-nowrap inline-flex items-center justify-center gap-1.5 rounded-full bg-primary-500 px-4 py-2 text-sm text-background-50 transition-colors hover:bg-primary-600"
                        >
                          查看完整清单
                        </a>
                        <a
                          href="#talk"
                          className="whitespace-nowrap inline-flex items-center justify-center gap-1.5 rounded-full border border-foreground-300 px-4 py-2 text-sm text-foreground-800 transition-colors hover:border-foreground-950"
                        >
                          去讨论区补楼
                        </a>
                      </div>
                    </div>
                  </div>
                )}
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}